var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.showPushSettings)?_c('div',{staticClass:"csn-push-notifications-button"},[_c('cs-button',{attrs:{"corners":"rounded","block":""},on:{"click":_vm.enableNotifications}},[_c('i',{staticClass:"cs-icons-notification-filled"}),_vm._v("  Enable Push Notifications ")])],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }